// extracted by mini-css-extract-plugin
module.exports = {"containerItems":"styles_containerItems__2-Gly","module":"styles_module__SOa_7"};